import React, { useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getMineSaleOrderList, relistSaleProductAPI } from "../../../../redux/sale/action";
import { useEffect } from "react";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import { Commas, getDateFormate } from "../../../Common/AllDateTimeReleventFormate";
import useChatNavigation from "../../../Common/useChatNavigation";
import ProfilePic from "../../../../assests/imgs/Profileplaceholder.svg";

export default function Productforsale() {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { letChat } = useChatNavigation();


  const salelist = useSelector(({ sale: { minesaleorderlist } }) => minesaleorderlist);

  useEffect(() => {
    dispatch(getMineSaleOrderList(4));
  }, []);

  const RelistAPI = (item, id) => {
    if (item?.relist_id > 0) {
      return null
    }
    else {
      const data = {
        "sale_id": id,
        "relist": "1"
      }
      dispatch(relistSaleProductAPI(data))
    }
  }

  let lastDisplayedDate = null;

  return (
    <>
      <div className="posted-project umbrellaproject-sec pending-req">
        <>
          {/* <h4>Purchase requests history ({salelist?.length || 0})</h4> */}
          {
            Array.isArray(salelist) && salelist?.length > 0 ?
              <>
                {salelist.map((item, index) => {
                  const currentDate = item.created_on.split(" ")[0];
                  const shouldDisplayDate = currentDate !== lastDisplayedDate;
                  lastDisplayedDate = currentDate;
                return(
                  <div className="pending-row" key={index}>
                    {shouldDisplayDate && <h6 className="date-name">{getDateFormate(item.created_on)}</h6>}
                    <div className="pending-img ">
                      <div className="row align-items-center">
                        <div className="col-md-5">
                          <div className="pending-left">
                            <img src={item?.cover ? item?.cover : Array.isArray(item?.files) && item?.files[0]?.file} alt="" />
                            <div>
                              <h5>{item?.title}</h5>
                              <h3>$ {Commas(item?.total_price ? item?.total_price : item?.price)}</h3>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="pending-center">
                            <img src={item?.profile_image ? item?.profile_image:ProfilePic} alt="" />
                            <div>
                              <p>{item?.is_mine == 0 ? 'Seller' : 'Ordered by'}
                                <p> <img src={`${CloudStorage.cloudurl}/Assets/Images/common/star-1.svg`} alt="" /> {item?.rating || 0} ({item?.reviews || 0} reviews)</p>
                              </p>
                              <h5>{item?.first_name} {item?.last_name}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="pending-right">
                            <button onClick={() => RelistAPI(item, item?.sale_id)} className="buttons border-button">
                              {item?.relist_id > 0 ? 'Already-listed' : 'Re-list'}    </button>
                            <button onClick={() => letChat(item)} className="buttons border-button">
                              <img src={`${CloudStorage.cloudurl}/Assets/Images/common/message-color.svg`} alt="" />
                            </button>
                            <button className="btn-img" onClick={() => { navigate(`/${lan}/dashboard/receivedorders/productforsaledetails/${item?.id}`) }}>
                              <img src={`${CloudStorage.cloudurl}/Assets/Images/common/right-color-icon.svg`} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )})
                }
              </>
              :
              <PostNotFound title={"No Post Found"} height={200} />
          }

        </>
      </div>
    </>
  );
}
